export default __webpack_public_path__ + "static/media/GodsDebris.06a38779.png";